import { conversionsAndSwatchTargets } from "./conversionsAndSwatchTargets";

function camelize(str) {
  return str
    .replace(/[\-\/\\_]/gi, "")
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/\s+/g, "");
}

const safeCategoryKeyName = (value) => camelize(value);

const referenceOrder = [
  "Drifter",
  "Expedition",
  "Ranger",
  "Roamer",
  "Adventurer",
  "Voyager",
  "Wayfarer",
];

const getTextureUrlFromSwatch = (swatch) => {
  // If swatch is default uphostery, DON'T set a texture, use model default.
  if (
    swatch.category.toLowerCase() === "upholstery" &&
    swatch.name.toLowerCase() === "vw standard"
  ) {
    console.log("handleSwatchImageUrl() has blocked swatch texture", swatch);
    return null;
  }

  return swatch.image;
};

export const generateOptions = (swatches, extras) => {
  return {
    vanType: {
      title: "Van Type",
      options: [
        {
          title: "VW Van",
          svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192.74 192.74" width="50px" fill="#aaa">  <g fill-rule="evenodd" clip-rule="evenodd">   <path d="M96.336 2.865c-51.663 0-93.543 41.882-93.543 93.543 0 51.662 41.881 93.543 93.543 93.543 51.66 0 93.543-41.881 93.543-93.543 0-51.66-41.883-93.543-93.543-93.543zm0 178.699c-47.031 0-85.156-38.125-85.156-85.156 0-47.029 38.125-85.155 85.156-85.155 47.029 0 85.156 38.126 85.156 85.155 0 47.031-38.127 85.156-85.156 85.156z"></path>  <path d="M77.692 32.786a66.308 66.308 0 0 1 18.644-2.657c6.465 0 12.715.926 18.623 2.652l-18.623 41.28-18.644-41.275z"></path>  <path d="M131.914 40.477a66.695 66.695 0 0 1 17.957 16.847l-30.566 67.64-11.795-26.227H85.162l-11.794 26.226-30.522-67.702a66.635 66.635 0 0 1 17.909-16.783l24.407 54.146h22.424l24.328-54.147zM32.296 79.254a66.384 66.384 0 0 0-2.241 17.154c0 25.975 14.939 48.458 36.694 59.329L32.296 79.254z"></path>  <path d="M78 160.12a66.268 66.268 0 0 0 18.336 2.569c6.354 0 12.498-.895 18.314-2.562l-18.314-40.673L78 160.12zM125.92 155.737c21.756-10.871 36.695-33.354 36.695-59.329 0-5.88-.766-11.581-2.201-17.009l-34.494 76.338z"></path>  </g>  </svg>`,
          value: true,
          message:
            "Compatible Dimensions for VW vans: [TO GET DIMENSIONS]. Have something else? Get in touch!",
        },
        {
          title: "Ford Van",
          svg: `<svg fill="#aaa" width="80px" version="1.1" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="1 40.7 128.4 48.2"> <path d="M65.2,40.7C29.6,40.7,1,51.4,1,64.8c0,13.3,28.8,24.1,64.2,24.1c35.4,0,64.2-10.8,64.2-24.1 	C129.5,51.6,100.6,40.7,65.2,40.7z M65.2,86.8c-34,0-61.5-9.8-61.5-22c0-12.1,27.6-22,61.5-22c34,0,61.5,9.8,61.5,22 	C126.8,77,99.2,86.8,65.2,86.8z M90.5,69.7c0,0.1,0,0.2,0,0.2c0,0.1,0.2,0.2,0.3,0.3c0,0,0.1,0.1,0,0.2c-0.4,0.9-0.8,1.4-1.3,2.1 	c-0.5,0.7-1,1.2-1.6,1.7c-0.9,0.8-2.3,1.6-3.4,1.1c-0.5-0.3-0.7-0.9-0.7-1.5c0-1.5,0.7-3.1,2-4.7c1.5-1.9,3.3-2.9,4.4-2.3 	C91.4,67.3,91.1,68.7,90.5,69.7z M58.7,59.7c-0.1-0.6,0.1-1.3,0.7-1.8c0.3-0.3,0.7-0.3,1-0.1c0.3,0.2,0.1,0.8-0.1,1.3 	c-0.3,0.5-0.8,0.9-1.3,0.9C58.8,59.9,58.7,59.9,58.7,59.7z M65.2,44.7c-32.8,0-59.4,9.1-59.4,20.2C5.8,75.9,32.4,85,65.2,85 	c32.8,0,59.4-9.1,59.4-20.2C124.6,53.7,98,44.7,65.2,44.7z M34.7,78.1c-3.5,0-6.6-2.1-7-5.9c-0.2-2.1,0.4-3.9,1.6-5.5 	c1-1.4,2.8-2.5,4.3-2.8c0.5-0.1,1.1,0,1.4,0.3c0.4,0.5,0.3,1-0.1,1.3c-1.1,0.6-2.5,1.6-3.2,2.9c-0.6,1.1-0.7,2.5,0.2,3.7 	c1.4,2.1,5.3,2.2,9-1.2c0.9-0.8,1.7-1.6,2.5-2.6c1.6-1.8,2.1-2.5,4.3-5.5c0,0,0-0.1,0-0.1c0,0,0,0-0.1-0.1c-1.4,0-2.7,0.5-3.9,1.4 	c-0.3,0.3-0.8,0.2-1.1-0.1c-0.2-0.4-0.1-0.9,0.3-1.1c1.9-1.4,4.1-1.6,6.2-2c0,0,0.2,0,0.3-0.2c0.9-1.1,1.6-2.2,2.5-3.3 	c1-1.2,2.2-2.2,3.1-3.1c1.3-1.1,2.2-1.5,3-2c0.2-0.1,0-0.3-0.1-0.3c-4.8-0.9-9.8-2.1-14.5-0.3c-3.3,1.2-4.7,3.8-4,5.6 	c0.5,1.2,2.1,1.4,3.7,0.7c1.3-0.6,2.4-1.6,3.3-2.9c0.5-0.7,1.4-0.2,0.9,1c-1.4,3.3-4.1,5.9-7.3,6c-2.8,0.1-4.5-1.9-4.5-4.4 	c0-4.9,5.5-8.2,11.3-8.7c7-0.6,13.6,1.3,20.5,2.1c5.3,0.6,10.4,0.7,15.7-0.6c0.6-0.1,1.1,0.3,1,0.9c-0.1,0.9-0.8,1.8-2.5,2.8 	c-2,1.1-4.1,1.4-6.3,1.4c-5.3,0-10.2-2-15.3-3.1c0,0.2,0.1,0.5-0.1,0.6c-2.8,2.1-5.4,4.2-7.1,7.1c-0.1,0.1,0,0.1,0.1,0.1 	c1.5-0.1,2.8-0.1,4.2-0.2c0.2,0,0.2-0.1,0.2-0.3c-0.1-1,0.2-2.2,1.1-3c0.9-0.8,2.1-0.9,2.8-0.3c0.9,0.7,0.8,1.9,0.3,2.8 	c-0.5,0.9-1.3,1.4-2,1.7c0,0-0.2,0-0.1,0.2c0,0.2,1.1,0.8,1.2,1c0.1,0.1,0,0.4-0.1,0.5c-0.1,0.1-0.3,0.2-0.5,0.2 	c-0.2,0-0.3-0.1-0.5-0.2c-0.5-0.3-1.1-0.7-1.4-1.2c-0.1-0.2-0.2-0.2-0.5-0.2c-1.5,0.1-3.8,0.3-5.4,0.5c-0.4,0-0.4,0.1-0.5,0.3 	c-2.5,4.1-5.2,8.6-8.2,11.6C40.2,77.2,37.5,78.1,34.7,78.1z M103,57.9c-0.5,0.8-9.9,15.2-10.5,16.6c-0.2,0.5-0.2,0.8,0,1.1 	c0.5,0.7,1.6,0.3,2.3-0.2c2-1.4,3.4-3.1,5-4.6c0.1-0.1,0.2-0.1,0.3,0c0.2,0.2,0.6,0.5,0.8,0.7c0.1,0.1,0.1,0.2,0,0.3 	c-1.5,1.9-3.2,3.6-4.8,4.9c-2.5,1.9-5,2.4-6.3,1.2c-0.5-0.5-0.7-1.1-0.7-1.7c0-0.3-0.2-0.3-0.3-0.2c-1.5,1.5-4.1,3.1-6.4,1.9 	c-2-1-2.4-3.3-2-5.3c0,0,0-0.3-0.3-0.2c-0.4,0.3-0.9,0.6-1.6,0.9c-0.8,0.3-1.2,0.4-2,0.4c-1,0-1.8-0.4-2.4-1.4 	c-0.3-0.5-0.5-1.3-0.5-1.9c0-0.1-0.1-0.2-0.2,0c-1.6,2.4-3.1,4.8-4.7,7.3c-0.1,0.1-0.2,0.2-0.3,0.2c-1,0-2.1,0-3.1,0 	c-0.2,0-0.3-0.1-0.2-0.3c0.6-1.1,3.6-5.5,5.7-9.3c0.6-1,0.5-1.6,0.1-1.8c-0.4-0.3-1.3,0.1-2.1,0.7c-2,1.5-3.7,3.9-4.6,5 	c-0.5,0.6-1,1.6-2.3,3c-2.1,2.3-4.9,3.6-7.5,2.7c-1.5-0.5-2.5-1.7-2.9-3.1c-0.1-0.3-0.2-0.4-0.4-0.2c-0.4,0.5-1.3,1.3-2.1,1.8 	c-0.1,0.1-0.3,0.2-0.5,0.1c-0.2-0.1-0.7-0.8-0.8-1.1c-0.1-0.2,0-0.3,0.1-0.4c1.1-0.9,1.6-1.5,2.1-2c0.3-0.4,0.6-0.9,0.9-1.7 	c0.6-1.6,2.1-4.6,5-6.2c1.1-0.6,2.2-1,3.5-1.2c0.5-0.1,1,0,1.1,0.4c0.1,0.2,0.2,0.6,0.3,0.8c0.1,0.2,0,0.3-0.2,0.4 	c-1.7,0.7-3.4,1.7-4.6,3.3c-1.4,1.8-1.7,4-0.8,5.2c0.7,0.9,1.7,1.1,2.8,0.7c1.6-0.5,2.9-1.9,3.6-3.6c0.7-1.8,0.9-3.8,0.3-5.7 	c-0.1-0.3,0-0.6,0.2-0.7c0.4-0.3,1-0.6,1.1-0.7c0.4-0.2,0.8-0.1,1,0.2c0.6,0.8,0.9,2,0.9,3.3c0,0.3,0.1,0.3,0.3,0.1 	c1-1.1,2-2.2,3-3.1c1-0.8,2.3-1.4,3.4-1.4c1.5,0,2.3,1.1,2.2,2.9c0,0.2,0.2,0.2,0.3,0.1c0.5-0.7,0.8-1,1.3-1.4 	c1.1-0.9,2.1-1.3,3.3-1.2c1.4,0.1,2.5,1.4,2.3,2.8c-0.1,0.9-0.7,1.8-1.5,2.2c-0.7,0.4-1.6,0.3-2.2-0.2c-0.5-0.4-0.6-1.1-0.5-1.7 	c0-0.1-0.1-0.3-0.3-0.1c-1.4,1.4-1.5,3.2-0.6,4.1c1,0.9,2.4,0.3,3.5-0.4c2-1.3,3.5-3,5.2-4.4c1.2-0.9,2.5-1.7,4-1.9 	c0.8-0.1,1.6-0.1,2.4,0.3c1.1,0.4,1.7,1.3,1.8,2.1c0,0.2,0.2,0.3,0.3,0.1c0.8-1.3,5.4-8.1,5.8-8.8c0.1-0.2,0.2-0.3,0.5-0.3 	c1,0,2.3,0,3.2,0C103,57.7,103,57.8,103,57.9z"></path> </svg>`,
          value: false,
          message:
            "Compatible Dimensions for Ford vans: [TO GET DIMENSIONS]. Have something else? Get in touch!",
        },
        {
          title: "Other",
          value: false,
          message:
            "Note: `Other` includes vans like the: Renault Trafic, Vauxhall Vivaro, Toyota Proace, Nissan Prime Star, Fiat Skudo & Mercedes Vito. If you're not sure, get in touch!",
        },
      ],
    },

    wheelbase: {
      title: "Wheelbase",
      options: [
        {
          title: "SWB",
          svg: `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" enable-background="new 0 0 64 64" xml:space="preserve" viewBox="7 7 50 50" width="50px" fill="#aaa"><path d="M56.708,7.293C56.521,7.105,56.267,7,56.001,7l-48,0.001c-0.265,0-0.52,0.105-0.707,0.293S7.001,7.736,7.001,8.001    L7.002,56c0,0.553,0.448,1,1,1h47.999c0.553,0,1-0.447,1-1V8C57.001,7.735,56.896,7.48,56.708,7.293z M55.001,55H9.002    L9.001,9.001l46-0.001V55z"></path><path d="M16,33h9.586l-2.293,2.293c-0.391,0.391-0.391,1.023,0,1.414C23.488,36.902,23.744,37,24,37s0.512-0.098,0.707-0.293l4-4    c0.391-0.391,0.391-1.023,0-1.414l-4-4c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414L25.586,31H16c-0.552,0-1,0.448-1,1    S15.448,33,16,33z"></path><path d="M39.293,36.707C39.488,36.902,39.744,37,40,37s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414L38.414,33H48    c0.553,0,1-0.448,1-1s-0.447-1-1-1h-9.586l2.293-2.293c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0l-4,4    c-0.391,0.391-0.391,1.023,0,1.414L39.293,36.707z"></path></svg>`,
          value: true,
        },
        {
          title: "LWB",
          svg: `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" enable-background="new 0 0 64 64" xml:space="preserve" viewBox="7 7 50 50" width="50px" fill="#aaa"><g><g><path d="M56.708,7.293C56.521,7.105,56.267,7,56.001,7l-48,0.001c-0.265,0-0.52,0.105-0.707,0.293S7.001,7.736,7.001,8.001    L7.002,56c0,0.553,0.448,1,1,1h47.999c0.553,0,1-0.447,1-1V8C57.001,7.735,56.896,7.48,56.708,7.293z M55.001,55H9.002    L9.001,9.001l46-0.001V55z"></path><path d="M19.295,36.707C19.491,36.902,19.747,37,20.002,37s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414l-2.292-2.292    h27.169l-2.293,2.292c-0.391,0.391-0.391,1.023,0,1.414C43.488,36.902,43.744,37,44,37s0.512-0.098,0.707-0.293l4-3.999    C48.895,32.521,49,32.266,49,32.001s-0.105-0.52-0.293-0.707l-4-3.999c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.024,0,1.414    l2.293,2.292H18.417l2.292-2.292c0.391-0.39,0.391-1.023,0-1.414s-1.023-0.391-1.414,0l-4,4c-0.188,0.188-0.293,0.442-0.293,0.707    s0.105,0.52,0.293,0.707L19.295,36.707z"></path></g></g></svg>`,
          value: false,
        },
      ],
    },

    boot: {
      title: "Van's Boot",
      options: [
        {
          title: "Barn Doors",
          imageUrl: "/media/images/boot-doors/barn.png",
          value: "Barn Doors",
        },
        {
          title: "Tailgate Door",
          imageUrl: "/media/images/boot-doors/tailgate.png",
          value: "Tailgate Door",
        },
      ],
    },

    trim: {
      title: "Which trim would you like?",
      options: [
        {
          title: "Standard Trim",
          svg: `<svg xmlns="http://www.w3.org/2000/svg" width="50px" fill="#aaa" viewBox="0 0 384 512"><path d="M326.6 166.6L349.3 144 304 98.7l-22.6 22.6L192 210.7l-89.4-89.4L80 98.7 34.7 144l22.6 22.6L146.7 256 57.4 345.4 34.7 368 80 413.3l22.6-22.6L192 301.3l89.4 89.4L304 413.3 349.3 368l-22.6-22.6L237.3 256l89.4-89.4z"/></svg>`,
          value: "standard",
        },
        {
          title: "Eco Trim",
          svg: `<svg xmlns="http://www.w3.org/2000/svg" width="50px" fill="#aaa" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M307.3 207c82.9-9.1 148.4-75.6 156-159H456c-76.7 0-142 49.1-166.1 117.5c-8.8-16.8-19.4-32.6-31.6-47.1C296.1 48 370.5 0 456 0h24c17.7 0 32 14.3 32 32c0 113.6-84.6 207.4-194.2 222c-2.1-16.2-5.6-31.9-10.5-47.1zM48 112v16c0 97.2 78.8 176 176 176h8V288c0 0 0 0 0 0c0-97.2-78.8-176-176-176H48zM280 288v16 48l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136h-8C100.3 352 0 251.7 0 128V96C0 78.3 14.3 64 32 64H56c123.7 0 224 100.3 224 224z"/></svg>`,
          value: "eco",
        },
        {
          title: "Birch Trim",
          svg: `<svg xmlns="http://www.w3.org/2000/svg" width="50px" fill="#aaa" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M392 188.1V176l-15.3-16L257.2 34.8 224 0 190.8 34.8 71.3 160 56 176v12.1V208H89.5h2.3H104L56 256 40 272 24 288v24.2V320H56h3.9H72h8L40 368 13.3 400 0 416v32H48 200v40 24h48V488 448H400h48V416l-13.3-16L408 368l-40-48h8 12.1H392h32v-7.8V288l-16-16-16-16-48-48h12.2 2.3H392V188.1zM248 400V216 192H200v24V400H75.8l41.1-49.3L144 318.2V272H107.9l30.1-30.1L176 203.9V160H137.6L224 69.5 310.4 160H272v43.9l38.1 38.1L340.1 272H304v46.2l27.1 32.6L372.2 400H248z"/></svg>`,
          value: "birch",
        },
      ],
    },

    conversions: Object.keys(conversionsAndSwatchTargets)
      .map((key) => ({
        key,
        title: conversionsAndSwatchTargets[key].name,
        ...conversionsAndSwatchTargets[key],
      }))
      .sort(
        (a, b) =>
          referenceOrder.indexOf(a.title) - referenceOrder.indexOf(b.title)
      ),

    swatches: {
      ...swatches.reduce((carry, swatch) => {
        const key = safeCategoryKeyName(swatch.category);

        carry = {
          ...carry,
          [key]: {
            ...(carry[key] ? carry[key] : {}),
            title: swatch.category,
            options: [
              ...(carry[key] ? carry[key].options : []),
              {
                textureUrl: getTextureUrlFromSwatch(swatch),
                imageUrl: swatch.image,
                price: swatch.price,
                title: swatch.name,
                category: swatch.subcategory,
              },
            ],
          },
        };

        return carry;
      }, {}),
    },

    extras: {

      hasWindowUpgradesDriverSideFrontWindow: {
        title: "Driver-side front window",
        options: [
          {
            title: "Fake",
            imageUrl: "/media/images/windows/driver-side-front-window.png",
            value: "fake",
            message: "Selected: Fake Window - looks like a window from the outside"
          },
          {
            title: "Fixed",
            imageUrl: "/media/images/windows/driver-side-front-window.png",
            value: "fixed",
            message: "Selected: Fixed Window - normal window, cannot be opened"
          },
          {
            title: "Opener",
            imageUrl: "/media/images/windows/driver-side-front-window.png",
            value: "opener",
            message: "Selected: Opener Window - normal window with opener for air"
          },
          {
            title: "Panel",
            imageUrl: "/media/images/windows/driver-side-front-window.png",
            value: "panel",
            message: "Selected: Panel - no window"
          },
        ],
      },

      hasWindowUpgradesDriverSideRearWindow: {
        title: "Driver-side rear window",
        options: [
          {
            title: "Fake",
            imageUrl: "/media/images/windows/driver-side-rear-window.png",
            value: "fake",
            message: "Selected: Fake Window - looks like a window from the outside"
          },
          {
            title: "Fixed",
            imageUrl: "/media/images/windows/driver-side-rear-window.png",
            value: "fixed",
            message: "Selected: Fixed Window - normal window, cannot be opened"
          },
          {
            title: "Opener",
            imageUrl: "/media/images/windows/driver-side-rear-window.png",
            value: "opener",
            message: "Selected: Opener Window - normal window with opener for air"
          },
          {
            title: "Panel",
            imageUrl: "/media/images/windows/driver-side-rear-window.png",
            value: "panel",
            message: "Selected: Panel - no window"
          },
        ],
      },

      hasWindowUpgradesPassengerSideFrontWindow: {
        title: "Passenger-side front window",
        options: [
          {
            title: "Fake",
            imageUrl: "/media/images/windows/passenger-side-front-window.png",
            value: "fake",
            message: "Selected: Fake Window - looks like a window from the outside"
          },
          {
            title: "Fixed",
            imageUrl: "/media/images/windows/passenger-side-front-window.png",
            value: "fixed",
            message: "Selected: Fixed Window - normal window, cannot be opened"
          },
          {
            title: "Opener",
            imageUrl: "/media/images/windows/passenger-side-front-window.png",
            value: "opener",
            message: "Selected: Opener Window - normal window with opener for air"
          },
          {
            title: "Panel",
            imageUrl: "/media/images/windows/passenger-side-front-window.png",
            value: "panel",
            message: "Selected: Panel - no window"
          },
        ],
      },

      hasWindowUpgradesPassengerSideRearWindow: {
        title: "Passenger-side rear window",
        options: [
          {
            title: "Fake",
            imageUrl: "/media/images/windows/passenger-side-rear-window.png",
            value: "fake",
            message: "Selected: Fake Window - looks like a window from the outside"
          },
          {
            title: "Fixed",
            imageUrl: "/media/images/windows/passenger-side-rear-window.png",
            value: "fixed",
            message: "Selected: Fixed Window - normal window, cannot be opened"
          },
          {
            title: "Opener",
            imageUrl: "/media/images/windows/passenger-side-rear-window.png",
            value: "opener",
            message: "Selected: Opener Window - normal window with opener for air"
          },
          {
            title: "Panel",
            imageUrl: "/media/images/windows/passenger-side-rear-window.png",
            value: "panel",
            message: "Selected: Panel - no window"
          },
        ],
      },

      hasWindowUpgradesBootWindow: {
        title: "Boot window",
        options: [
          {
            title: "Fake",
            imageUrl: "/media/images/windows/boot-window.png",
            value: "fake",
            message: "Selected: Fake Window - looks like a window from the outside"
          },
          {
            title: "Fixed",
            imageUrl: "/media/images/windows/boot-window.png",
            value: "fixed",
            message: "Selected: Fixed Window - normal window, cannot be opened"
          },
          {
            title: "Panel",
            imageUrl: "/media/images/windows/boot-window.png",
            value: "panel",
            message: "Selected: Panel - no window"
          },
        ],
      },

      ...extras.reduce((carry, extra) => {
        const key = safeCategoryKeyName(extra.category);

        carry = {
          ...carry,
          [key]: {
            ...(carry[key] ? carry[key] : {}),
            title: extra.category,
            options: [
              ...(carry[key] ? carry[key].options : []),
              {
                imageUrl: extra.imageSrc,
                title: extra.name,
                category: extra.category,
                price: extra.price,
                url: extra.url,
                hideOnBuilder: extra.hideOnBuilder,
              },
            ],
          },
        };

        return carry;
      }, {}),
    },
  };
};

export const filterByEnabledSwatchesOnConversion = (conversion, swatches) => {
  const enabledSwatchTargetKeys = Object.keys(
    conversionsAndSwatchTargets[conversion].swatchTargets
  );

  return Object.keys(swatches)
    .filter((swatchKey) => enabledSwatchTargetKeys.includes(swatchKey))
    .reduce((carry, key) => {
      return {
        ...carry,
        [key]: swatches[key],
      };
    }, []);
};

/**
 * Array of mapped sections for the sidebar.
 * @returns {Array<object>}
 */
export const sectionDictionary = [
  {
    ref: "section5",
    title: "Select Your Van Colour",
    description: "Pick your van colour or the closest match",

    categories: [
      {
        type: "swatch",
        name: "vanColours",
      },
    ],
  },

  {
    ref: "section6",
    title: "Design Your Pop-top",
    description: "Pick your colours and extras",

    categories: [
      {
        type: "swatch",
        name: "popTopCanvas",
      },
      {
        type: "extra",
        name: "poptopOptionalExtras",
        selectType: "hasRules",
        rules: {
          incompatibleIndexes: [
            "poptopOptionalExtras1",
            "poptopOptionalExtras3",
          ],
        },
      },
    ],
  },

  {
    ref: "section7",
    title: "Van Wall Lining",
    description: "Pick the carpet lining of your van.",

    categories: [
      {
        type: "swatch",
        name: "vanWallLining4WayStretchCarpet",
      },
    ],
  },

  {
    ref: "section8",
    title: "Design Your Kitchen",
    description: "Pick your colours and extras",

    categories: [
      {
        type: "configured",
        name: "trim",
        optionIndex: "trim",
      },
      {
        type: "swatch",
        name: "kitchenUnits",
      },
      {
        type: "swatch",
        name: "worktopFinishes",
      },
      {
        type: "swatch",
        name: "splashbacks",
      },
      {
        type: "swatch",
        name: "fridgeColour",
      },

      {
        type: "extra",
        name: "additionalCookingOptions",
        selectType: "single",
      },
      {
        type: "extra",
        name: "additionalKitchenStorage",
      },
      {
        type: "extra",
        name: "tableUpgrades",
      },
      {
        type: "extra",
        name: "heatingUpgrades",
        selectType: "single",
      },
    ],
  },

  {
    ref: "section9",
    title: "Design Your Flooring",
    description: "Pick your colours",

    categories: [
      {
        type: "swatch",
        name: "flooringRange",
      },
    ],
  },

  {
    ref: "section10",
    title: "Design Your Seating",
    description: "Pick your material & extras",

    categories: [
      {
        type: "extra",
        name: "seatingUpgrades",
        selectType: "hasRules",
        rules: {
          incompatibleIndexes: ["seatingUpgrades1", "seatingUpgrades4"],
        },
      },
      {
        type: "swatch",
        name: "upholstery",
      },
    ],
  },

  {
    ref: "section11",
    title: "Design Your Windows",
    description: "Pick your windows & blinds",

    categories: [
      {
        type: "extra",
        name: "hasWindowUpgradesDriverSideFrontWindow",
        extraIndex: "hasWindowUpgradesDriverSideFrontWindow",
        selectType: "single",
        showTitles: true,
        hasMessages: true,
      },
      {
        type: "extra",
        name: "hasWindowUpgradesDriverSideRearWindow",
        extraIndex: "hasWindowUpgradesDriverSideRearWindow",
        selectType: "single",
        showTitles: true,
        hasMessages: true,
      },
      {
        type: "extra",
        name: "hasWindowUpgradesBootWindow",
        extraIndex: "hasWindowUpgradesBootWindow",
        selectType: "single",
        showTitles: true,
        hasMessages: true,
      },
      {
        type: "extra",
        name: "hasWindowUpgradesPassengerSideRearWindow",
        extraIndex: "hasWindowUpgradesPassengerSideRearWindow",
        selectType: "single",
        showTitles: true,
        hasMessages: true,
      },
      {
        type: "extra",
        name: "hasWindowUpgradesPassengerSideFrontWindow",
        extraIndex: "hasWindowUpgradesPassengerSideFrontWindow",
        selectType: "single",
        showTitles: true,
        hasMessages: true,
      },
      {
        type: "swatch",
        name: "blindsCurtains",
      },
    ],
  },

  {
    ref: "section12",
    title: "Choose Your Charging Upgrades",
    description: "Pick your extras",

    categories: [
      {
        type: "extra",
        name: "chargingUpgrades",
      },
    ],
  },

  {
    ref: "section13",
    title: "Design the Outside",
    description: "Pick your extras",

    categories: [
      {
        type: "extra",
        name: "externalStyling",
        selectType: "hasRules",
        rules: {
          incompatibleIndexes: ["externalStyling0", "externalStyling1"],
        },
      },
      {
        type: "extra",
        name: "externalAttachments",
        selectType: "hasRules",
        rules: {
          incompatibleIndexes: ["externalAttachments0", "externalAttachments2"],
        },
      },
    ],
  },

  {
    ref: "section14",
    title: "Choose Your Tracking",
    description: "Pick your extras",

    categories: [
      {
        type: "extra",
        name: "tracking&Safety",
      },
    ],
  },

  {
    ref: "nonfittedExtras",
    title: "Choose Your Non-Fitted Extras",
    description: "Pick your extras",

    categories: [
      {
        type: "extra",
        name: "nonfittedExtras",
      },
    ],
  },
];
